/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { EventItem } from '../../models/event-item';
import { UpdateEventDto } from '../../models/update-event-dto';

export interface EventControllerUpdate$Params {
  monitoringId: number;
  id: number;
      body: UpdateEventDto
}

export function eventControllerUpdate(http: HttpClient, rootUrl: string, params: EventControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EventItem;
}>> {
  const rb = new RequestBuilder(rootUrl, eventControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('monitoringId', params.monitoringId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EventItem;
      }>;
    })
  );
}

eventControllerUpdate.PATH = '/monitoring/{monitoringId}/events/{id}';
